/* 2026-10-25 (Claude). Joel: "Yes, move the remaining shared inline blocks into cached asset files the same way, and measure before and after".
   Moved out of snippets/aoam-gallery-rail.liquid so browsers cache it instead of downloading it inside every page. Same code as the inline copy it replaced, notes kept as comments (the CDN strips them).
   Edit THIS file now. Roll back: restore snippets/aoam-gallery-rail.liquid from OneDrive/Documents/AOAM-Theme-Backups/2026-10-25-inline-move/ and delete this file. */
(function () {
  if (window.AOAM_GAL_RAIL) return;
  window.AOAM_GAL_RAIL = '2026-09-30b';
  function wire(photos) {
    if (!photos || photos.getAttribute('data-aoam-rail')) return;
    var scroller, main, count;
    /* Look everything up fresh on each sync: a second counter span was seen on light-painting-tube
       (intermittent, the stale one sat under the live one), so keep exactly one and re-find it. */
    function parts() {
      scroller = photos.querySelector('.product-thumbs__scroller');
      main = photos.querySelector('.product__main-photos');
      if (!scroller || !main) return false;
      var all = photos.querySelectorAll('.aoam-gal-count');
      for (var k = 1; k < all.length; k++) all[k].parentNode.removeChild(all[k]);
      count = all[0];
      if (count && count.parentNode !== main) { count.parentNode.removeChild(count); count = null; }
      if (!count) {
        count = document.createElement('span');
        count.className = 'aoam-gal-count';
        count.setAttribute('aria-hidden', 'true');
        main.appendChild(count);
      }
      return true;
    }
    if (!parts()) return;
    photos.setAttribute('data-aoam-rail', '1');
    function fades() {
      if (!scroller) return;
      var over = scroller.scrollHeight > scroller.clientHeight + 1;
      scroller.classList.toggle('aoam-fade-t', over && scroller.scrollTop > 2);
      scroller.classList.toggle('aoam-fade-b', over && scroller.scrollTop + scroller.clientHeight < scroller.scrollHeight - 2);
    }
    function sync() {
      if (!parts()) return;
      var items = Array.prototype.filter.call(scroller.querySelectorAll('.product__thumb-item'), function (it) {
        return it.offsetParent !== null;
      });
      var active = scroller.querySelector('.product__thumb.is-active');
      var item = active ? active.closest('.product__thumb-item') : null;
      var i = items.indexOf(item);
      var slides = main.querySelectorAll('.product-main-slide');
      var cur = main.querySelector('.product-main-slide.is-selected');
      /* The slide gets is-selected the moment the slider moves, the thumb class is rewritten a beat
         later, so when both lists line up the slide is the fresher answer. */
      if (cur && slides.length === items.length) { i = Array.prototype.indexOf.call(slides, cur); item = items[i] || item; }
      count.innerHTML = (i < 0 ? 1 : i + 1) + ' <em>/ ' + (items.length || 1) + '</em>';
      if (item && getComputedStyle(scroller).flexDirection === 'column' && scroller.scrollHeight > scroller.clientHeight + 1) {
        var r = item.getBoundingClientRect(), s = scroller.getBoundingClientRect();
        if (r.top < s.top + 4) scroller.scrollTop += r.top - s.top - 16;
        else if (r.bottom > s.bottom - 4) scroller.scrollTop += r.bottom - s.bottom + 16;
      }
      fades();
    }
    new MutationObserver(sync).observe(photos, { subtree: true, attributes: true, attributeFilter: ['class'] });
    photos.addEventListener('click', function () { [0, 150, 600, 1100].forEach(function (ms) { setTimeout(sync, ms); }); });
    photos.addEventListener('scroll', fades, { passive: true, capture: true });
    window.addEventListener('resize', fades, { passive: true });
    /* Joel 2026-09-30 "make the thumbnail rail scroll with the mouse wheel". The desktop and phone rails
       are vertical and the browser already wheel-scrolls them. The 750-1080px row is horizontal, which a
       wheel never scrolls, so map the wheel onto it; at either end the page scrolls as normal. */
    photos.addEventListener('wheel', function (e) {
      if (!scroller || e.ctrlKey || !e.target.closest || !e.target.closest('.product-thumbs__scroller')) return;
      if (getComputedStyle(scroller).flexDirection === 'column') return;
      var d = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : 0;
      if (!d) return;
      if (e.deltaMode === 1) d *= 16; else if (e.deltaMode === 2) d *= scroller.clientWidth;
      var max = scroller.scrollWidth - scroller.clientWidth;
      if (max <= 1 || (d < 0 && scroller.scrollLeft <= 0) || (d > 0 && scroller.scrollLeft >= max - 1)) return;
      e.preventDefault();
      scroller.scrollBy({ left: d, behavior: 'instant' });
    }, { passive: false });
    sync();
  }
  function run() {
    document.querySelectorAll('#pdp-details-block .product__photos--below').forEach(wire);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
